<template>
  <v-container fluid style="max-width: 1280px;">
    <v-layout alig-start>
      <v-flex>
        <!-- Listado resumen diario -->
        <v-data-table :loading="loading" :headers="headers" :items="detalles" :items-per-page="15" item-key="idmovimiento"
          show-expand class="elevation-3" dense>
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title class="hidden-sm-and-down">RESÚMENES DIARIOS</v-toolbar-title>
              <v-divider class="mx-2 hidden-sm-and-down" inset vertical></v-divider>
              <v-spacer />
              <!-- busqueda de resumen diario -->
              <v-text-field class="mr-1" v-model.trim="buscar" dense label="Búsqueda" @keyup="listar()" single-line
                hide-details>
              </v-text-field>
              <v-spacer />
              <v-menu v-model="menuFechaBuscar" :close-on-content-click="!menuFechaBuscar" transition="scale-transition"
                offset-y min-width="290px" :close-on-click="dates.length == 2 ? true : false">
                <template v-slot:activator="{ on }">
                  <v-text-field dense v-model="dateRangeText" readonly v-on="on" hide-details class="mr-1"
                    append-icon="update" @click:append="listar()" style="max-width: 220px;"></v-text-field>
                </template>
                <v-date-picker v-model="dates"
                  @input="dates.length == 2 ? menuFechaBuscar = false : menuFechaBuscar = true" @change="listar()"
                  range></v-date-picker>
              </v-menu>
              <v-spacer />
              <!-- Fin Busqueda de resumen diario -->

              <!-- Modal crear resumen diario -->
              <v-dialog v-model="dialog" max-width="600px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" class="hidden-sm-and-down" v-on="on" @click="listarResumen()" small
                    outlined>Nuevo
                  </v-btn>
                  <v-btn color="primary" class="hidden-md-and-up" v-on="on" @click="listarResumen()" fab x-small outlined>
                    <v-icon>add</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar dark dense class="primary" flat>
                    <v-toolbar-title>Registrar Resumen</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-form v-model="isValid">
                      <v-row class="mt-2 mb-2">
                        <v-spacer />
                        <v-col cols="7" sm="4">
                          <v-menu v-model="menuFecha" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field dense readonly label="Fec. Emisión Comprob."
                                v-model="fecha_emision_formateada" v-on="on" prepend-inner-icon="event" hide-details>
                              </v-text-field>
                            </template>
                            <v-date-picker v-model="fecha_emision" @input="menuFecha = false"
                              @change="fechaseleccionada(fecha_emision), detalles_resumen_dia = [], listarResumen();">
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="1">
                          <v-btn x-small fab color="primary" @click="listarResumen()" class="white--text"
                            :loading="loadingdia" :disabled="loadingdia">
                            <v-icon>update</v-icon>
                          </v-btn>
                        </v-col>
                        <v-spacer />
                      </v-row>
                      <v-data-table :loading="loadingdia" :headers="cabeceraResumenDiario" :items="detalles_resumen_dia"
                        class="elevation-3" dense>
                        <template v-slot:item.num="{ item }">
                          <td>{{ detalles_resumen_dia.indexOf(item) + 1 }}</td>
                        </template>
                        <template v-slot:item.borrar="{ item }">
                          <v-icon small color="error" class="mr-2"
                            @click="eliminarItemDetalleResumen(detalles_resumen_dia, item)">delete_forever</v-icon>
                        </template>
                        <template v-slot:item.numero="{ item }">
                          <span>{{ item.serie_comprobante }}-{{ item.num_comprobante }}</span>
                        </template>
                        <template v-slot:item.subtotal_gravado="{ item }">
                          <div class="text-right">{{ item.subtotal_gravado | formatearNumero }}</div>
                        </template>
                        <template v-slot:item.gratuito="{ item }">
                          <div class="text-right">{{ item.gratuito | formatearNumero }}</div>
                        </template>
                        <template v-slot:item.igv_gravado="{ item }">
                          <div class="text-right">{{ item.igv_gravado | formatearNumero }}</div>
                        </template>
                        <template v-slot:item.importe_total="{ item }">
                          <div class="text-right">{{ item.importe_total | formatearNumero }}</div>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="py-0 pb-4 px-4 justify-center">
                    <v-btn color="error" @click="close" small outlined>
                      <v-icon left>close</v-icon>Cancelar
                    </v-btn>
                    <v-btn color="primary" @click="guardar" :loading="desabilitar"
                      :disabled="desabilitar || !isValid || detalles_resumen_dia == '' ? true : false" small outlined>
                      <v-icon left>check</v-icon>Guardar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Fin Modal crear resumen diario -->

              <!-- Modal anular Resumen Diario -->
              <v-dialog v-model="adModal" max-width="330">
                <v-card>
                  <v-card-title class="justify-center">¿Anular Resúmen Diario?
                  </v-card-title>
                  <v-card-text>
                    Estás a punto de
                    <span>Anular</span>
                    el Resúmen Diario: {{ adRDiario }}
                  </v-card-text>
                  <v-card-actions class="py-0 pb-4 justify-center">
                    <v-btn color="info" @click="anularCerrar" small outlined>Cancelar</v-btn>
                    <v-btn color="error" @click="anular" small outlined>Anular</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Fin Modal anular Resumen Diario -->
            </v-toolbar>
          </template>
          <!-- Opciones -->
          <template v-slot:item.fecha="{ item }">
            <span>{{ item.fecha | formatearFecha }}</span>
          </template>
          <template v-slot:item.fecha_comprobante="{ item }">
            <span>{{ item.fecha_comprobante | formatearFecha }}</span>
          </template>
          <template v-slot:item.identificador="{ item }">
            <span>{{ item.serie_comprobante + "-" + item.num_comprobante }}</span>
          </template>

          <template v-slot:item.estado="{ item }">
            <template v-if="item.estado == 'Aceptado'">
              <v-chip small color='success' class="white--text font-weight-bold" label>{{ item.estado }}</v-chip>
            </template>
            <template v-else-if="item.estado == 'Rechazado'">
              <v-chip small color='error' class="white--text font-weight-bold" label>{{ item.estado }}</v-chip>
            </template>
            <template v-else-if="item.estado == 'Enviado'">
              <span class="primary--text">{{ item.estado }}</span>
            </template>
            <template v-else-if="item.estado == 'Por enviar'">
              <span class="brown--text">{{ item.estado }}</span>
            </template>
            <template v-else-if="item.estado == 'En proceso'">
              <span class="pink--text">{{ item.estado }}</span>
            </template>
            <template v-else>
              <span>{{ item.estado }}</span>
            </template>
          </template>

          <template v-slot:item.descargas="{ item }">
            <template v-if="item.estado == 'Enviado' || item.estado == 'Aceptado'">
              <v-chip color="cyan" class="white--text" x-small @click="descargarXml(item)">XML</v-chip>
            </template>
            <template v-if="item.estado == 'Aceptado'">
              <v-chip color="teal" class="white--text" x-small @click="descargarCdr(item)">CDR</v-chip>
            </template>
          </template>
          <template v-slot:item.opciones="{ item }">
            <template v-if="item.estado == 'Enviado' && !isNaN(item.nro_ticket) || item.estado == 'En proceso'">
              <v-btn x-small color="primary" class="white--text" @click="consultarTicket(item)" :loading="consultar"
                :disabled="consultar">Consultar</v-btn>
            </template>
            <template v-if="item.estado == 'Por enviar' || item.estado == 'Creado'">
              <v-btn x-small color="brown" class="white--text" @click="reenviarResumen(item)" :loading="consultar"
                :disabled="consultar">Reenviar</v-btn>
            </template>
            <template
              v-if="usuario.idusuario == 1 && item.estado == 'Enviado' && !isNaN(item.nro_ticket) || item.estado == 'Creado' || item.estado == 'Por enviar' || item.estado == 'En proceso'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small icon v-bind="attrs" v-on="on">
                    <v-icon color="error" @click="anularMostrar(item)">delete</v-icon>
                  </v-btn>
                </template>
                <span>Anular</span>
              </v-tooltip>
            </template>
          </template>
          <!-- Fin Opciones -->
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <strong>Registrado por:</strong>
              {{ item.usuario }}
              <br />
              <strong v-if="item.msj_cdr.length > 0">SUNAT:</strong>
              {{ item.msj_cdr }}
            </td>
          </template>
        </v-data-table>
        <!-- Fin Listado resumen diario -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      detalles: [],
      detalles_resumen_dia: [],
      dialog: false,
      headers: [
        { text: "...", value: "data-table-expand", align: "center" },
        { text: "FEC. EMISIÓN", value: "fecha", sortable: false },
        { text: "FEC. REF.", value: "fecha_comprobante", sortable: false },
        { text: "IDENTIFICADOR", value: "identificador", sortable: false, width: 140 },
        { text: "TICKET", value: "nro_ticket", sortable: false },
        { text: "ESTADO", value: "estado", sortable: false },
        { text: "", value: "descargas", sortable: false },
        { text: "OPCIÓN", value: "opciones", sortable: false },
      ],

      cabeceraResumenDiario: [
        { text: "", value: "borrar", sortable: false },
        { text: "#", value: "num", sortable: false },
        { text: "MON.", value: "cod_moneda", sortable: false },
        { text: "NÚMERO", value: "numero", sortable: false },
        { text: "GRAVADA", value: "subtotal_gravado", sortable: false },
        { text: "GRATUITO", value: "gratuito", sortable: false },
        { text: "IGV", value: "igv_gravado", sortable: false },
        { text: "TOTAL", value: "importe_total", sortable: false },
      ],
      buscar: "",

      fecha_emision_formateada: "",
      fecha_emision: moment().format("YYYY-MM-DD"),
      menuFecha: false,

      desabilitar: false,
      consultar: false,
      isValid: true,
      loadingdia: false,

      loading: false,

      adModal: 0,
      adId: "",
      adRDiario: "",

      dates: [
        moment().startOf("year").format("YYYY-MM-DD"),
        moment().endOf("year").format("YYYY-MM-DD"),
      ],
      menuFechaBuscar: false,
    };
  },

  computed: {
    ...mapState(["usuario", "datos"]),

    dateRangeText() {
      let fechaIni;
      let fechaFin;
      for (var i = 0; i < this.dates.length; i++) {
        fechaIni = this.common.formatDate(this.dates[0]);
        fechaFin = this.common.formatDate(this.dates[1]);
      }
      let arrayFechas = [fechaIni, fechaFin];
      return arrayFechas.join(" ~ ");
    },
  },

  created() {
    this.fechaseleccionada(this.fecha_emision);
    this.listar();
  },

  methods: {
    ...mapActions(["snackBar", "cargarNotifCpes"]),

    fechaseleccionada(dia) {
      let arrayFecha = dia.split(["-"]);
      let ddmmyy = arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
      this.fecha_emision_formateada = ddmmyy;
    },

    /* Listar detalles */
    listar() {
      let me = this;
      me.loading = true;

      if (me.buscar == "") {
        axios.get("api/Movimientos/ListarResumenesDiarios", {
          params: {
            idsucursal: parseInt(me.usuario.idsucursal),
            idusuario: parseInt(me.usuario.idusuario),
            buscar: me.buscar == "" ? "-" : me.buscar,
            fechaInicio: me.dates[0],
            fechaFin:
              me.dates[1] == undefined
                ? me.dates[0] + " 23:59:59"
                : me.dates[1] + " 23:59:59",
          },
        })
          .then(function (response) {
            me.detalles = response.data;
            me.loading = false;
            me.cargarNotifCpes();// Actualizamos Notificacion Cpes
          })
          .catch((err) => {
            //console.log(err.response);
          });
      } else {
        axios.get("api/Movimientos/ListarResumenesDiariosTotal", {
          params: {
            idsucursal: parseInt(me.usuario.idsucursal),
            buscar: me.buscar == "" ? "-" : me.buscar,
            fechaInicio: me.dates[0],
            fechaFin:
              me.dates[1] == undefined
                ? me.dates[0] + " 23:59:59"
                : me.dates[1] + " 23:59:59",
          },
        })
          .then(function (response) {
            me.detalles = response.data;
            me.loading = false;
          })
          .catch((err) => {
            //console.log(err.response);
          });
      }

    },
    /* Fin Listar detalles */

    /* Guardar resumen diario */
    guardar() {
      let me = this;
      me.desabilitar = true;

      //Código para guardar
      axios.post("api/Movimientos/CrearResumenDiario", {
        idsucursal: parseInt(me.usuario.idsucursal),
        idusuario: parseInt(me.usuario.idusuario),
        fecha_comprobante: me.fecha_emision,
        detalles_resumen_dia: me.detalles_resumen_dia,
      })
        .then(function (response) {
          me.snackBar({ cl: response.data.rptcolor, msg: response.data.respuesta }); // Respuesta de sunat
          me.ocultarNuevo();
          me.listar();
        })
        .catch(function (error) {
          me.snackBar({ cl: "error", msg: error.response.data }); // Error de Pc
          me.listar();
        });
    },

    listarResumen() {
      let me = this;
      me.loadingdia = true;
      var ResumenDiaArray = [];
      me.detalles_resumen_dia = [];

      axios.get("api/Movimientos/ListarResumenDiaFiltro", {
        params: {
          idsucursal: parseInt(me.usuario.idsucursal),
          idusuario: parseInt(me.usuario.idusuario),
          fecha: me.fecha_emision,
        },
      })
        .then(function (response) {
          ResumenDiaArray = response.data; // recorremos el array
          ResumenDiaArray.map(function (x) {
            me.detalles_resumen_dia.push({
              idmovimiento: x.idmovimiento,
              num_documento: x.num_documento,
              idtipo_comprobante: x.idtipo_comprobante,
              idtipo_documento: x.idtipo_documento,
              serie_comprobante: x.serie_comprobante,
              num_comprobante: x.num_comprobante,
              comprobante_afectado: x.ref_comprobante.substring(3, 16),
              cod_tipo_comprobante_afectado: x.ref_comprobante.substring(0, 2),
              cod_status: "1",
              cod_moneda: x.idtipo_servicio == 5 ? "PEN" : "USD",//5=PEN / 6=USD
              //inafecto: 0,
              //exonerado: 0,
              gratuito: x.gratuito,
              subtotal_gravado: x.subtotal_gravado,
              igv_gravado: x.igv_gravado,
              importe_total: x.importe_total,
              afecta_stock: x.afecta_stock,
            });
          });
          me.loadingdia = false;
        })
        .catch((err) => {
          //console.log(err.response);
        });
    },

    reenviarResumen(item) {
      let me = this;
      me.consultar = true;

      axios.put("api/Movimientos/ReenviarResumenDiarioSunat/" + item.idmovimiento)
        .then(function (response) {
          me.snackBar({ cl: response.data.rptcolor, msg: response.data.respuesta }); // Respuesta de sunat
          me.listar();
          me.limpiar();
        })
        .catch(function (error) {
          me.limpiar();
          console.log(error.response.data)
          me.snackBar({ cl: "error", msg: error.response.data }); // Error de Pc
        });
    },

    consultarTicket(item) {
      let me = this;
      me.consultar = true;

      axios.put("api/Movimientos/ConsultarTicket/" + item.idmovimiento)
        .then(function (response) {
          me.snackBar({ cl: response.data.rptcolor, msg: response.data.respuesta }); // Respuesta de sunat
          me.listar();
          me.limpiar();
        })
        .catch(function (error) {
          me.limpiar();
          me.snackBar({ cl: "error", msg: error.response.data }); // Error de Pc
        });
    },

    descargarXml(item) {
      let me = this;

      axios.get("api/Movimientos/DescargarXmlResumen/" + item.idmovimiento)
        .then(function (response) {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            me.datos.ruc +
            "-" +
            item.serie_comprobante +
            "-" +
            item.num_comprobante +
            ".xml"
          );
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch(function (error) {
          me.snackBar({ cl: "error", msg: error.response.data });
        });
    },

    descargarCdr(item) {
      let me = this;

      axios.get("api/Movimientos/DescargarCdrResumen/" + item.idmovimiento)
        .then(function (response) {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            "R-" +
            me.datos.ruc +
            "-" +
            item.serie_comprobante +
            "-" +
            item.num_comprobante +
            ".xml"
          );
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch(function (error) {
          me.snackBar({ cl: "error", msg: error.response.data });
        });
    },

    ocultarNuevo() {
      this.dialog = 0;
      this.limpiar();
    },

    // Eliminar detalle pedido
    eliminarItemDetalleResumen(arr, item) {
      var i = arr.indexOf(item);
      if (i !== -1) {
        arr.splice(i, 1);
      }
    },

    /* Cerrar ventana resumen diario */
    close() {
      this.dialog = false;
      this.limpiar();
    },

    /* Anular */
    anularMostrar(item) {
      this.adModal = 1;
      this.adId = item.idmovimiento;
      this.adRDiario = item.num_comprobante;
    },

    anularCerrar() {
      this.limpiarAnular();
    },

    anular() {
      let me = this;

      axios.put("api/Movimientos/AnularRdiarioCbaja/" + me.adId)
        .then(function (response) {
          me.snackBar({ cl: response.data.rptcolor, msg: response.data.respuesta }); // Respuesta de sunat
          me.limpiarAnular();
          me.listar();
        })
        .catch(function (error) {
          me.snackBar({ cl: "error", msg: error.response.data });
          me.limpiarAnular();
        });
    },

    limpiarAnular() {
      this.adModal = 0;
      this.adId = "";
      this.adRDiario = "";
    },
    /* Fin Anular */

    /* Limpiar resumen diario item */
    limpiar() {
      this.desabilitar = false;
      this.consultar = false;

      this.detalles_resumen_dia = [];

      this.fecha_emision = moment().format("YYYY-MM-DD");
      this.fechaseleccionada(this.fecha_emision); // Cargamos fecha actual a fecha_comprobante y fecha_comprobate_formateada
    },
  },
};
</script>
